export const AVAILABLE_NIGHTS_PARAM = 'availableNights';
export const AVAILABLE_WEEKENDS_PARAM = 'availableWeekends';
export const IN_PERSON_PARAM = 'inPerson';
export const FREE_CONSULTATION_PARAM = 'freeConsultation';

export const MORE_FILTERS_EXTENDED_AVAILABILITY_OPTIONS = [
  {
    param: AVAILABLE_NIGHTS_PARAM,
    indicator: 'availabilityOnNightsIndicator',
    optionId: 'available-evenings',
    kind: AVAILABLE_NIGHTS_PARAM,
    labelKey: 'booking.clinicianSearch.filterDetail.availableEvenings',
  },
  {
    param: AVAILABLE_WEEKENDS_PARAM,
    indicator: 'availabilityOnWeekendsIndicator',
    optionId: 'available-weekends',
    kind: AVAILABLE_WEEKENDS_PARAM,
    labelKey: 'booking.clinicianSearch.filterDetail.availableWeekends',
  },
];

export const MORE_FILTERS_SESSION_TYPE_OPTIONS = [
  {
    param: IN_PERSON_PARAM,
    indicator: 'inPersonAppointmentsIndicator',
    optionId: 'in-person',
    kind: IN_PERSON_PARAM,
    labelKey: 'booking.clinicianSearch.filterDetail.inPerson',
  },
  {
    param: FREE_CONSULTATION_PARAM,
    indicator: 'freeConsultationsIndicator',
    optionId: 'free-consultation',
    kind: FREE_CONSULTATION_PARAM,
    labelKey: 'booking.clinicianSearch.filterDetail.freeConsultation',
  },
];

export const MORE_FILTERS_BOOLEAN_OPTIONS = [
  ...MORE_FILTERS_EXTENDED_AVAILABILITY_OPTIONS,
  ...MORE_FILTERS_SESSION_TYPE_OPTIONS,
];

export function buildMoreFiltersBooleanOptionRows(records, routeParams, filterClinicians) {
  return MORE_FILTERS_BOOLEAN_OPTIONS.map(spec => {
    let cohortRouteParams = { ...routeParams, [spec.param]: null };
    let docCount = filterClinicians(records, cohortRouteParams).filter(
      record => !!record?.[spec.indicator]
    ).length;

    return { ...spec, docCount };
  });
}
